import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';
import './Hyperlink.scss';

const Hyperlink = ({ node }: RichTextContentProps) => {
  const { data } = node;

  if (!data) {
    return null;
  }

  if (
    node.content &&
    node.content[0].value &&
    node.content[0].value.toLowerCase() === 'youtube-embed'
  ) {
    return (
      <iframe
        id="ytplayer"
        src={data.uri?.replace('/watch?v=', '/embed/')}
        title={data.uri}
        className="youtube-embed"
        allowFullScreen
      ></iframe>
    );
  }

  return (
    <a href={data.uri} target="_blank" rel="noreferrer">
      <RichTextContent node={node} />
    </a>
  );
};

export default Hyperlink;
